export default __webpack_public_path__ + "static/status.postmarkapp.com-fcebc1c6abbb099b48eb83c1791a2ed8.webp";